import React, { useState, useEffect } from 'react';
import { Music2, Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled 
          ? 'bg-black/95 backdrop-blur-lg shadow-lg border-b border-[#D4AF37]/10' 
          : 'bg-transparent'
      }`}
    >
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between h-20">
          <div 
            className="flex items-center space-x-3 cursor-pointer group" 
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          >
            <div className="relative">
              <Music2 className="w-6 h-6 text-[#D4AF37] group-hover:text-[#FFB547] transition-colors" />
              <div className="absolute inset-0 blur-lg bg-[#D4AF37] opacity-20 group-hover:opacity-40 transition-opacity"></div>
            </div>
            <span className="text-3xl artist-name text-white">ΞLI7Λ</span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('music')} 
              className="text-sm font-medium text-gray-300 hover:text-[#D4AF37] transition-colors"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Music
            </button>
            <button 
              onClick={() => scrollToSection('about')} 
              className="text-sm font-medium text-gray-300 hover:text-[#D4AF37] transition-colors"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('writing')} 
              className="text-sm font-medium text-gray-300 hover:text-[#D4AF37] transition-colors"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Writing
            </button>
            <button 
              onClick={() => scrollToSection('events')} 
              className="text-sm font-medium text-gray-300 hover:text-[#D4AF37] transition-colors"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Events
            </button>
            <Button
              className="bg-[#D4AF37] hover:bg-[#FFB547] text-black border-0 font-semibold"
              size="sm"
              onClick={() => scrollToSection('contact')}
            >
              Connect
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-[#D4AF37]"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="md:hidden pb-6 space-y-4 border-t border-[#D4AF37]/10 pt-4">
            <button 
              onClick={() => scrollToSection('music')} 
              className="block w-full text-left py-2 text-gray-300 hover:text-[#D4AF37] transition-colors"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Music
            </button>
            <button 
              onClick={() => scrollToSection('about')} 
              className="block w-full text-left py-2 text-gray-300 hover:text-[#D4AF37] transition-colors"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              About
            </button>
            <button 
              onClick={() => scrollToSection('writing')} 
              className="block w-full text-left py-2 text-gray-300 hover:text-[#D4AF37] transition-colors"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Writing
            </button>
            <button 
              onClick={() => scrollToSection('events')} 
              className="block w-full text-left py-2 text-gray-300 hover:text-[#D4AF37] transition-colors"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Events
            </button>
            <Button
              className="w-full bg-[#D4AF37] hover:bg-[#FFB547] text-black"
              onClick={() => scrollToSection('contact')}
            >
              Connect
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;